import crypto from "../images/crypto-website.JPG"
import debtfix from "../images/debtfix-website.JPG"
import gpt3 from "../images/gp3-website.JPG"
import movie from "../images/movie-website.JPG"
import space from "../images/space-tourism-website.JPG"
import tracker from "../images/tracker-website.JPG"
import amnid from "../images/amnid-website.JPG"
import blog from "../images/blog-api.jpg"
import kanban from "../images/Kanban-app.JPG"
import chatapp from "../images/chatchord.JPG"
import events from "../images/event.jpg"
import linkurl from "../images/linkurl.JPG"
import telemedicine from "../images/telemedicine.png"

export const data = [
  {
    id: "16",
    title: "Telemedicine",
    img: telemedicine,
    content: `A telemedicine platform that allows patients to book appointments and consult doctors online.`,
    github: "https://github.com/Simplystina/telemedicin-backend",
    live: "https://telemedicinae.netlify.app/",
    tools: `Frontend: Vite + React + Zustand | Backend: Nodejs + Typescript + Postgres`
  },
  {
    id: "15",
    title: "LinkURL",
    img: linkurl,
    content: `LinkURL is a webapp that shortens url, generates url code of shortened urls and shows the analysis of the the generated urls`,
    github: "https://github.com/Simplystina/url-shortener/tree/master",
    live: "https://linkurl.netlify.app/",
    tools : `Nodejs + Nodemailer + Mongodb + QrCodeGenerator`
  },
  {
      id: "9",
     title :"Blog API" ,
     img: blog,
     content :`A Blog API that include full blog CRUD operations, authentication of users and authorization of authenticated users`,
     github:"https://github.com/Simplystina/Blogging_API-Alt-School-Project",
     documentation:"https://documenter.getpostman.com/view/19697282/2s8ZDbX1Za",
     tools: `Nodejs + express + Passport + MongoDb`
   },
   {
    id: "10",
     title :"KanBan Task API" ,
     img: kanban,
     content :`Kanban board is a tool that let users manage their work properly at both personal or organizational level`,
     github:"https://github.com/Simplystina/KanBan-App-API",
     live: "https://kanban-sage.vercel.app/",
     tools: `Nodejs + express + Passport + MongoDb`
    },
    {
      id: "13",
       title :"ShowCase API" ,
       img: events,
       content :`This is an event ticketing API service.`,
       github:"https://github.com/Simplystina/Showcase_API",
       documentation:"https://documenter.getpostman.com/view/19697282/2s93RZKoeD",
       tools: `Nodejs + express + PayStack API + MongoDb`
      },
    {
      id: "11",
       title :"CharCord Messaging Bot" ,
       img: chatapp,
       content :`Charcord is a restaurant bolt messaging app that allows users make orders at a restaurant, view previous orders, display orders`,
       github:"https://github.com/Simplystina/CharCord-",
       live:"https://charcord-chat-app.onrender.com/",
       tools: `Nodejs + express + VanillaJs + MongoDb + Socketio`
      },
    {
        id: "1",
      title :"Tracker" ,
      img:tracker,
      content :`A valuable tool to analyse submitted 
      applications. It helps users save and keep track 
      of their pending job applications.`,
      github:"https://github.com/Simplystina/tracker-app",
      live:"https://tracker-webapp.netlify.app/",
      tools: `React + CSS + API's`
    },
    {
      id: "2",
    title :"AmNiD" ,
    img:amnid,
    content :`AmNiD is an online platform that utilizes the identity pass API to guarantee the security of online transactions.
    `,
    github:"https://github.com/Simplystina/Prembly-Hack-AmNiD-App",
    live:"https://amnid.vercel.app/",
    tools: `Next js + Chakra UI + Flask, using PostgreSQL as its database`
  },
    {
        id: "3",
        title :"Space Tourist Website" ,
        img: space,
        content :`A space tourist website for space travellers.
         It was built with react CSS and AOS for animation.`,
        github:"https://github.com/Simplystina/space-tourist-project",
        live:"https://space-tourism-webapp.netlify.app/",
        tools: `React + AOS + CSS`
      },
      
      {
        id:"4",
        title: "Debtfix",
        img: debtfix,
        content:"A debt managing app that helps users to manage their debt",
        live:"https://debtfix.netlify.app/",
        github: "https://github.com/Simplystina/AWI-Hackathon",
        tools: `React + Django + Chakra UI` 
      },

    {
        id:"5",
        title: "Movie App",
        img: movie,
        content: `A fully responsive web application for finding and saving information about your favorite movies and TV shows.`,
        live: "https://movio-webapp.netlify.app/",
        github: "https://github.com/Simplystina/movie-website",
        tools: `React + CSS Animations + API's`
    },
    {
        id: "6",
        title: "GP3 AI",
        img: gpt3,
        content: "The landing page of a gp3 AI website",
        live: "https://gp3-site.netlify.app/",
        github: "https://github.com/Simplystina/Gp3AI-project",
    },
    {
        id: "8",
        title: "Cryptoverse",
        img: crypto,
        content: `A webapp that displays recent news about coins in the crypto market`,
        live : "https://crypto-verse-project.netlify.app/",
        github : "https://github.com/Simplystina/CryptoVerse-Project",
    }

]